import Vue from 'vue'
import Router from 'vue-router'
const index = resolve => require.ensure( [], () =>resolve(require('@/components/Index/Index')))

const error =  resolve => require.ensure( [], () =>resolve(require('@/components/error')))

const tjIndex = resolve => require.ensure( [], () =>resolve(require('@/components/tianjing/Index')))
// 个人消息
const myMsg = resolve => require.ensure( [], () =>resolve(require('@/components/Message/myMsg')))
// 报警中心
const myAlarmMsg = resolve => require.ensure( [], () =>resolve(require('@/components/Message/myAlarmMsg')))
const download = resolve => require.ensure( [], () =>resolve(require('@/components/public/download')))

// 内页
const view = resolve => require.ensure( [], () =>resolve(require('@/components/tianjing/homePages/layoutPage/index')))
// 系统支持
const systemSupport = resolve => require.ensure( [], () =>resolve(require('@/components/tianjing/homePages/systemSupport/index')))

Vue.use(Router)
export const routeMap = [
  {
    path:"*",
    component:error,
  },
  {
    path: '/',
    component: tjIndex,
    meta: {requireAuth: true},
    children:[
      {
        path: '',
        name: 'index',
        component: index,
        meta: {requireAuth: true},
      },
      {
        path: 'tjIndex',
        name: 'tjIndex',
        component: tjIndex,
        meta: {requireAuth: true},
      }
    ],
  },
  {
    path: '/myMsg',
    name: 'myMsg',
    component: myMsg,
    meta: {requireAuth: true},
  },
  {
    path: '/myAlarmMsg',
    name: 'myAlarmMsg',
    component: myAlarmMsg,
    meta: {requireAuth: true},
  },
  {
    path: '/download',
    name: 'download',
    component: download,
    meta: {requireAuth: false},
  },
  {
    path: '/view',
    name: 'view',
    component: view,
    meta: {requireAuth: false},
  },
  {
    path: '/systemSupport',
    name: 'systemSupport',
    component: systemSupport,
    meta: {requireAuth: false},
  }
]
const router = new Router({
  routes: routeMap
});
router.beforeEach((to, from, next) => {
  if(to.name==='index'){
    if(window.homePageUrl){
      window.location.href = window.homePageUrl
      return
    }
  }
  if (to.query.Token) {
    delete to.query.Token;
    delete to.query.PlatformClientPort;
    router.replace({path:to.path,query:to.query})
    return;
  }
  if (to.matched.some(r => r.meta.requireAuth)) {
    if((to.name == "func" || to.name == "alarm" || to.name == "map") && !to.query.functionCode){
      next("/")
    }
    next();
  } else {
    next();
  }
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js